export type EstimationType = 'none' | 'freeform' | 'fibonacci' | 'tshirt' | 'exponential'

export interface EstimationScale {
  label: string
  values: Array<number> | null
  displayLabels?: Array<string>
}

export const ESTIMATION_SCALES: Record<EstimationType, EstimationScale> = {
  none: { label: 'None', values: null },
  freeform: { label: 'Free-form', values: null },
  fibonacci: { label: 'Fibonacci', values: [0, 0.5, 1, 2, 3, 5, 8, 13, 21] },
  tshirt: {
    label: 'T-shirt sizing',
    values: [0, 1, 2, 3, 4],
    displayLabels: ['XS', 'S', 'M', 'L', 'XL'],
  },
  exponential: { label: 'Exponential', values: [1, 2, 4, 8, 16, 32] },
}

/** Get display label for an estimation value given the estimation type */
export function getEstimationDisplayLabel(
  value: number | null,
  type: EstimationType,
): string {
  if (value === null || value === undefined) return 'Estimate'
  const scale = ESTIMATION_SCALES[type]
  if (scale.displayLabels && value >= 0 && value < scale.displayLabels.length) {
    return scale.displayLabels[value] ?? String(value)
  }
  return String(value)
}
